import {
  ActionOrigin,
  Page,
  PageSection,
  UpdateType,
  useTrackingClient,
} from 'src/context/tracking';
import { FileAttachment } from 'src/forms/common/AttachmentSelect/AttachmentSelect';
import { useProfileAnalytic } from 'src/hooks/useProfileAnalytic';

export function useTracking() {
  const client = useTrackingClient();
  const {
    profileApproachabilityStatus,
    profileSharedStatus,
    profileVisibilityLevel,
  } = useProfileAnalytic();

  const trackProfileUpdate = () => {
    client.trackLink({
      link: 'profile_update_succeeded',
      currentPage: Page.DOCUMENT_PAGE,
      actionOrigin: ActionOrigin.APPLY,
      updateType: UpdateType.ADD,
      currentPageSection: PageSection.RESUME,
      profileApproachabilityStatus,
      profileSharedStatus,
      profileVisibilityLevel,
      resumeSelectedType: FileAttachment.UPLOAD,
    });
  };

  return { trackProfileUpdate };
}
